import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadoCobro'
})
export class EstadoCobroPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if(value === 1){
      return 'Pago Tesorería';
    }else if(value === 2){
      return 'Programado';
    }else if(value === 3){
      return 'Pendiente';
    }else if(value === 4){
      return 'Reprogramado';
    }else if(value === 6){
      return 'Abono Deuda';
    }else if(value === 7){
      return 'Abono Extra';
    }else if(value === 8){
      return 'Pago Cobrador'
    }else{
      return 'No Pago';
    }

  }

}
